import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useScopedAdminPath } from '@/shared/hooks/use-scoped-admin-path'
import { generatePath } from '@/shared/libs/generate-path'
import { Button } from '@/shared/ui/button'
import { PageHeader } from '@/shared/ui/page-header'

interface FormHeaderProps {
  isEdit: boolean
  tenantId: string
  tenantName: string
  onBack: () => void
}

/** Page title, breadcrumbs and the way back to the list. Saving lives in the step footer (create) or each section (edit). */
export function FormHeader({ isEdit, tenantId, tenantName, onBack }: FormHeaderProps) {
  const { t } = useTranslation()
  const scopedAdminPath = useScopedAdminPath()
  const title = isEdit ? t('tour.edit') : t('tour.create')
  const tenantBreadcrumbs = tenantId
    ? [
        {
          label: tenantName,
          path: scopedAdminPath(generatePath('/tenant/:tenantId', { tenantId })),
        },
      ]
    : []

  return (
    <PageHeader
      title={title}
      breadcrumbs={[
        { label: t('sidebar.tenants'), path: scopedAdminPath('/tenant') },
        ...tenantBreadcrumbs,
        {
          label: t('sidebar.tours'),
          path: scopedAdminPath(generatePath('/tenant/:tenantId/tours', { tenantId })),
        },
        { label: title },
      ]}
      actions={
        <Button variant="outline" onClick={onBack}>
          <ArrowLeft />
          {t('common.back')}
        </Button>
      }
    />
  )
}
